import isApiError from "@insite/client-framework/Common/isApiError";
import { patch, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { SessionModel } from "@insite/client-framework/Types/ApiModels";

export interface SendAccountActivationEmailApiParameter {
    userName: string;
    activateAccount: boolean;
}

export type Session = Omit<SessionModel, "billTo" | "shipTo"> & {
    billToId?: string;
    shipToId?: string;
};

const sessionsUrl = "/api/v1/sessions";

function cleanSession(session: SessionModel) {
    if (session.billTo) {
        (session as Session).billToId = session.billTo.id;
        delete (session as Partial<typeof session>)?.["billTo"];
    }

    if (session.shipTo) {
        (session as Session).shipToId = session.shipTo.id;
        delete (session as Partial<typeof session>)?.["shipTo"];
    }
}

export async function customSendAccountActivationEmail(
    parameter: SendAccountActivationEmailApiParameter,
): Promise<ServiceResult<SessionModel>> {
    try {
        const session = await patch<SessionModel>(`${sessionsUrl}/current`, {
            ...parameter,
        });
        cleanSession(session);
        return {
            successful: true,
            result: session,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
